export default {
      id: "shape-bottom-2000-usage",
      viewBox: "0 0 2000 251.8",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#shape-bottom-2000-usage",
      toString: function () {
        return this.url;
      }
    }